<!-- src/components/Gauge.vue -->
<template>
    <svg
        ref="svg"
        @click="onClick"
        data-gauge
        viewBox="0 0 200 100"
        class="gauge"
    >
        <!-- Background arc -->
        <path
            class="gauge-path gauge-bg"
            d="M10,100 A90,90 0 0,1 190,100"
        />

        <!-- Foreground arc -->
        <path
            ref="fg"
            class="gauge-path gauge-fg"
            d="M10,100 A90,90 0 0,1 190,100"
            :style="`stroke-dasharray: ${dash} ${circumference}; stroke-dashoffset: 0;`"
        />

        <!-- Numeric label -->
        <text
            class="gauge-label"
            x="100" y="75"
            text-anchor="middle"
        >{{ clampedValue }}%</text>
    </svg>
</template>

<script setup>
import { computed, ref } from 'vue'

const model = defineModel({
    type: Number,
    default: 0
});

const svg = ref(null);
const fg  = ref(null);

const radius = 90;
const circumference = Math.PI * radius;

const clampedValue = computed(() =>
    Math.min(Math.max(Number(model.value || 0), 0), 100)
);

const percent = computed(() => clampedValue.value / 100);
const dash = computed(() => circumference * percent.value);

function onClick (e) {
    const s = svg.value;
    if (!s) return;

    const pt = s.createSVGPoint();
    pt.x = e.clientX;
    pt.y = e.clientY;
    const svgP = pt.matrixTransform(s.getScreenCTM().inverse());

    const cx = 100, cy = 100;
    const dx = svgP.x - cx;
    const dy = cy - svgP.y;

    let angle = Math.atan2(dy, dx) * 180 / Math.PI;
    if (angle < 0) angle += 360;
    angle = Math.max(0, Math.min(180, angle));

    const rawPct = angle / 180;
    const pct = 1 - rawPct;

    model.value = Math.round(pct * 100);
}
</script>

<style scoped>
.gauge {
    width: 85px;
    height: 80px;
    cursor: pointer;
}
[data-gauge] .gauge-path {
    fill: none;
    stroke-width: 20;
}
[data-gauge] .gauge-bg {
    stroke: #eee;
}
[data-gauge] .gauge-fg {
    stroke: #4caf50;
    stroke-linecap: round;
}
[data-gauge] .gauge-label {
    font-size: 20px;
    fill: #333;
    user-select: none;
    pointer-events: none;
}
</style>
